import React, { MouseEvent, useCallback } from "react";

import { Form } from "react-bootstrap";

import classNames from "classnames";

import styles from "./TableHeaders.module.scss";

interface TableHeadersProps<T> {
  headers: { label: string; accessor: keyof T; className?: string }[];
  sortColumn: keyof T;
  setSortColumn: (column: keyof T) => void;
  sortDirection?: "ascending" | "descending";
  customStyles?: { [key: string]: string };
  showHeaderCheckBox?: boolean;
  tableRowsContainCheckBox?: boolean;
  batchID?: string;
  handleHeaderCheckBoxChange?: (e: React.ChangeEvent<HTMLInputElement>, batchID: string) => void;
}

export const TableHeaders = <T,>({
  headers,
  sortColumn,
  setSortColumn,
  customStyles,
  showHeaderCheckBox = false,
  tableRowsContainCheckBox = false,
  sortDirection,
  batchID,
  handleHeaderCheckBoxChange,
}: TableHeadersProps<T>) => {
  const handleOnClick = useCallback(
    (event: MouseEvent<HTMLDivElement>, accessor: keyof T) => {
      event.stopPropagation();
      setSortColumn(accessor);
    },
    [setSortColumn],
  );

  const headerColor = customStyles?.["custom-header-color"] ?? styles["custom-header-color"];

  return (
    <thead className={styles["custom-table-header"]}>
      <tr className={classNames(headerColor)}>
        {tableRowsContainCheckBox &&
          (showHeaderCheckBox ? (
            <th className="py-3 b4">
              <Form.Check
                type="checkbox"
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => handleHeaderCheckBoxChange?.(e, batchID || "")}
              />
            </th>
          ) : (
            <th />
          ))}
        {headers.map(({ label, accessor, className }) => (
          <th
            key={String(accessor)}
            onClick={(event) => {
              handleOnClick(event, accessor);
            }}
            className={classNames(
              {
                [customStyles?.["table-head-sort-activated"] ?? ""]: accessor === sortColumn,
              },
              styles["table-header-text"],
              "px-2 py-3 b4 medium",
              className || "",
            )}
          >
            {label}
            {accessor === sortColumn && (
              <span className={styles["sort-indicator"]}>{sortDirection === "ascending" ? " ↑" : " ↓"}</span>
            )}
          </th>
        ))}
      </tr>
    </thead>
  );
};
